import { router, routerFuns } from "sw-hic";

routerFuns.init(
  {
    leisure: () => import("@/components/leisure"),
    db: () => import("@/components/db/index"),
    module: () => import("@/components/module/index"),
    page: () => import("@/components/page/index"),
    map: () => import("@/components/map/index"),
    log: () => import("@/components/log/index"),
    dynamic: () => import("@/components/dynamic/page"),
  },
  [
    {
      path: "/sso",
      name: "sso",
      component: () => import("@/components/sso"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/viewer",
      name: "viewer",
      component: () => import("@/components/dynamic/page"),
      meta: {
        requiresAuth: true,
      },
    }
  ]
);

// routerFuns.init(
//   [
//     {
//       path: "/db",
//       name: "db",
//       component: () => import("@/components/db/index"),
//       meta: {
//         requiresAuth: true,
//       },
//     },
//     {
//       path: "/module",
//       name: "module",
//       component: () => import("@/components/module/index"),
//       meta: {
//         requiresAuth: true,
//       },
//     },
//     {
//       path: "/page",
//       name: "page",
//       component: () => import("@/components/page/index"),
//       meta: {
//         requiresAuth: true,
//       },
//     },
//     {
//       path: "/map",
//       name: "map",
//       component: () => import("@/components/map/index"),
//       meta: {
//         requiresAuth: true,
//       },
//     },
//   ],
//   [
//     {
//       path: "/sso",
//       name: "sso",
//       component: () => import("@/components/sso"),
//       meta: {
//         requiresAuth: false,
//       },
//     },
//   ]
// );

export default router;
